import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './platform/App';
import UpdateAvailableToast from './platform/components/UpdateAvailableToast';
import { initErrorReporter } from './platform/lib/errorReporter';
import './index.css';

initErrorReporter();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
    <UpdateAvailableToast />
  </React.StrictMode>
);
